import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { InputsDarkTheme } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

export function PostPurchaseOriginalCompareAt() {
  const {
    props: {
      settings: { useOrigCompareWhenDiscounted },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const options: DropdownInputOption[] = [
    { label: `Use product compare price`, value: false },
    { label: `Use pre discount price as compare price`, value: true },
  ];

  const onChange = (val: DropdownInputOption) => {
    setProps((draft) => {
      draft.settings.useOrigCompareWhenDiscounted = val.value as boolean;
    });
  };

  return (
    <DropdownInput
      theme={InputsDarkTheme}
      options={options}
      defaultValue={useOrigCompareWhenDiscounted ? options[1] : options[0]}
      onChange={onChange}
      optionStyles={{ textTransform: `uppercase` }}
    />
  );
}
